import 'dropzone';

Dropzone.autoDiscover = false;
